import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do plastic surgeons get more consults beyond RealSelf?",
    "a": "Owned SEO plus procedure-specific pages plus a curated before/after gallery. RealSelf rents you visibility — your own SEO compounds. The lifetime value gap is enormous."
  },
  {
    "q": "Is Google Ads worth it for plastic surgery?",
    "a": "Yes — case values justify high CPCs, but only with proper tracking, consult-quality scoring, and a site that converts. Without those, ads burn budget."
  },
  {
    "q": "How important are before-and-after galleries?",
    "a": "Decisive. Surgeons who curate procedure-by-procedure galleries with consistent lighting and angles convert at dramatically higher rates than those with random or unsorted images."
  },
  {
    "q": "How do we compete with med spas on injectables?",
    "a": "Specialist positioning — surgeon-administered, anatomical knowledge, complication management. Pages that show why surgeon-led injectables differ from spa-led drive premium pricing."
  },
  {
    "q": "Do you handle multi-location surgical practices?",
    "a": "Yes — each location gets its own page, GBP, and local SEO. Surgical practices benefit especially from clear per-location surgeon bios."
  }
];

export const Route = createFileRoute("/plastic-surgeon-marketing-colorado")({
  head: () =>
    industryMarketingHead("Plastic Surgeon", "plastic surgery practice", "plastic-surgeon-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Plastic Surgeon"}
      industryLower={"plastic surgery practice"}
      slug={"plastic-surgeon-marketing-colorado"}
      subheadline={"We help Colorado plastic surgeons fill the OR calendar with high-value consults — breast, body, face — without paying RealSelf for every lead."}
      painPoints={["RealSelf and directory spend doesn't produce signed consults","Med spas confuse the market and undercut your perceived value","Your before-and-after gallery isn't doing the lifting it should"]}
      serviceDescriptions={{
        seo: "Rank for breast augmentation, lift, tummy tuck, rhinoplasty, facelift, and every procedure across every Colorado market.",
        googleMaps: "Own 'plastic surgeon near me' in the Map Pack with board-certification and outcome signals.",
        webDesign: "Procedure-specific pages with before/after galleries, surgeon credentials, and consult-booking funnels.",
        ppc: "Profitable Google Ads for high-ticket procedures with strict ROAS tracking and consult-quality screening.",
        geoAi: "Get cited when shoppers ask ChatGPT 'best plastic surgeon in Denver' or 'rhinoplasty near me'.",
        socialMedia: "Surgeon-led content that builds authority and converts the high-ticket consult.",
      }}
      testimonial={{"quote":"Consult quality changed completely. We dropped RealSelf and built a pipeline that books $15k–$40k surgical cases monthly.","role":"Board-Certified Plastic Surgeon","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Plastic surgeon marketing in Colorado Springs","description":"Reach high-value patients across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Plastic surgeon marketing in Denver","description":"Compete in Denver's high-stakes plastic surgery market."},{"to":"/boulder-digital-marketing","label":"Plastic surgeon marketing in Boulder","description":"Reach Boulder's premium aesthetic and wellness patient base."}]}
    />
  ),
});
